export default {"src":"/_next/static/media/Pre-approved.60a19dd7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};